import React from "react";
import SEO from "../common/SEO";
import FooterOne from "../common/footer/FooterOne";
import HeaderOne from "../common/header/HeaderOne";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import ContactLocation from "../component/contact/ContactLocation";
import SectionTitle1 from "../elements/section-title/SectionTitle1";
import FormCareers from "../component/contact/FormCareers";
import CounterUpTwo from "../component/counterup/CounterUpTwo";
import AboutThree from "../component/about/AboutThree";
import ClientSlider from "../component/client/ClientSlider";

const Careers = () => {
  return (
    <>
      <SEO title="Careers" />
      <main className="main-wrapper">
        <HeaderOne />
        <BreadCrumbOne subtitle="" title="Careers" page="Careers" />

        <div className="section custom-padding">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-12 col-lg-12">
                <div className="contact-form-box shadow-box mb--30">
                  <h3 className="title">
                    Submit your CV at{" "}
                    <a
                      style={{ color: "#562b7a" }}
                      href="mailto:career@ucwf.net"
                    >
                      career@ucwf.net
                    </a>{" "}
                    or apply below
                  </h3>
                  <FormCareers />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section section-padding bg-color-dark overflow-hidden">
          <div className="container">
            <SectionTitle1
              subtitle="Find Us"
              title="Our office"
              description="Office No. 905, 9th Floor Prism Tower, Happiness Street Business Bay PO Box 124377, Dubai, UAE"
              textAlignment="heading-light-left"
              textColor=""
            />
            <div className="row justify-content-center">
              <ContactLocation />
            </div>
          </div>
        </div>

        <CounterUpTwo />
        <AboutThree />
        <div className="container " style={{ paddingTop: "100px" }}>
          <SectionTitle
            subtitle="Our Clients"
            title="Our valued partners"
            textAlignment="heading-left mb--40"
            textColor=""
          />
        </div>
        <ClientSlider
          itemShow={4}
          colSize="col-md-3"
          columnGap="row-35"
          parentClass="your-custom-class"
        />

        <FooterOne parentClass="pt--150 pt_lg--100 pt_md--80 pt_sm--60" />
      </main>
    </>
  );
};

export default Careers;
